export default {"src":"/_next/static/media/calendarTooth_64.f52e3a91.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};